export default __webpack_public_path__ + "static/media/era.c3194b58.png";